import { labelGenerationActionTypes } from '../../actions/configurations/labelGenerationActions';

const LabelGenerationReducers = (state = {}, action) => {
  switch (action.type) {
  case labelGenerationActionTypes.GET_LABEL_GENERATION.LOADING: {
    const { getLabelGenerationLoading } = action;
    return {
      ...state,
      getLabelGenerationLoading,
    };
  }

  case labelGenerationActionTypes.GET_LABEL_GENERATION.SUCCESS: {
    const { labelGeneration } = action;
    return {
      ...state,
      labelGeneration,
    };
  }

  case labelGenerationActionTypes.UPDATE_LABEL_GENERATION.LOADING: {
    const { updateLabelGenerationLoading } = action;
    return {
      ...state,
      updateLabelGenerationLoading,
    };
  }

  case labelGenerationActionTypes.GET_GLOBAL_LABELS.LOADING: {
    const { getGlobalLabelsLoading } = action;
    return {
      ...state,
      getGlobalLabelsLoading,
    };
  }

  case labelGenerationActionTypes.GET_GLOBAL_LABELS.SUCCESS: {
    const { globalLabels } = action;
    return {
      ...state,
      globalLabels,
    };
  }

  case labelGenerationActionTypes.CREATE_LABEL.LOADING: {
    const { createLabelLoading } = action;
    return {
      ...state,
      createLabelLoading,
    };
  }

  case labelGenerationActionTypes.DELETE_LABEL.LOADING: {
    const { deleteLabelLoading } = action;
    return {
      ...state,
      deleteLabelLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default LabelGenerationReducers;
